import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui';
import { usePublishSerie } from './usePublishSerie';

interface PublishSerieButtonProps {
  productId: string;
  serieId: string;
}

/**
 * Tlačítko „Publikovat" v řádku stavů vrstev detailu seriálu (schválené umístění).
 * Spustí background job publikace a otevře okno detailu jobu.
 */
export function PublishSerieButton({ productId, serieId }: PublishSerieButtonProps) {
  const { t } = useTranslation('venua-planner');
  const { publish, isPending } = usePublishSerie(productId, serieId);

  return (
    <Button
      size="sm"
      variant="primary"
      iconLeft="play"
      loading={isPending}
      disabled={isPending}
      onClick={publish}
      data-testid="publish-serie-button"
    >
      {t('publish.action')}
    </Button>
  );
}
